/**
 * Open an external URL or downloadable asset reliably from any context.
 *
 * - In a normal browser tab: lets the native <a target="_blank"> open a new tab.
 * - Inside an iframe (e.g. the Emergent preview shell or any embed) the parent
 *   frame can block popups. In that case we navigate the top-level window
 *   instead, which is always allowed when initiated by a real user click.
 */
export function openExternal(e, url) {
  try {
    const inIframe = window.top !== window.self;
    if (inIframe) {
      if (e && typeof e.preventDefault === "function") e.preventDefault();
      try {
        window.top.location.href = url;
      } catch {
        window.location.href = url;
      }
    }
    // not in iframe → let the native anchor target="_blank" behavior run
  } catch {
    // window.top access denied → safest fallback
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    window.location.href = url;
  }
}
